import { Box, Divider, Typography } from "@mui/material";
import { mesfColors } from "@/setup/ag-grid/mesf-theme";
import type { CampaignBanner as CampaignBannerData } from "../models/TrendDisplay";

interface CampaignBannerProps {
	banner: CampaignBannerData | null | undefined;
}

const labelSx = {
	fontSize: "0.7rem",
	fontWeight: 700,
	letterSpacing: "0.1em",
	color: mesfColors.text.secondary,
	textTransform: "uppercase",
	lineHeight: 1.1,
};

const valueSx = {
	fontSize: "0.95rem",
	fontWeight: 700,
	color: mesfColors.text.primary,
	lineHeight: 1.2,
};

const productLabel = (
	banner: CampaignBannerData | null | undefined,
): string => {
	if (!banner?.ProductSizeName && !banner?.ProductTypeName) return "—";
	const type = banner?.ProductTypeName ? `(${banner.ProductTypeName}) ` : "";
	const size = banner?.ProductSizeName ?? "";
	return `${type}${size}`.trim();
};

export const CampaignBanner = ({ banner }: CampaignBannerProps) => {
	const recipeName = banner?.RecipeId ? (banner.RecipeName ?? "—") : null;

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 2,
				py: 0.75,
				px: 0.5,
			}}
		>
			<Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
				<Typography sx={labelSx}>Product</Typography>
				<Typography sx={valueSx}>{productLabel(banner)}</Typography>
			</Box>

			<Divider orientation="vertical" flexItem sx={{ my: 0.5 }} />

			<Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
				<Typography sx={labelSx}>Recipe</Typography>
				<Typography
					sx={{
						...valueSx,
						color: recipeName
							? mesfColors.text.primary
							: mesfColors.text.secondary,
						fontStyle: recipeName ? "normal" : "italic",
					}}
				>
					{recipeName ?? "(no recipe)"}
				</Typography>
			</Box>
		</Box>
	);
};
